import { createApp } from 'vue';
import NrwToPngConverter from '../Components/NrwToPngConverter.vue';

const root = document.getElementById('nrw-to-png-converter');
if (root) {
  createApp(NrwToPngConverter).mount('#nrw-to-png-converter');
}
